import { models } from '@kurtosys/ksys-app-template';
export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	// Locally we make use of the proxy to get the app to run.
	token: '31351716-729d-471c-b2c8-fe934776cf32',
	serviceUrl: 'https://api-rel.fundpress.io',
};
